import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';

function* sendNoticeException(action) {
  let response = null;
  try {
    response = yield call(
      requestAPI,
      API.API_EXCEPTION + '/send-notice',
      API.POST,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.SEND_EXCEPTION_NOTICE_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({ type: types.SEND_EXCEPTION_NOTICE_FAILED, error: response });
    }

    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.SEND_EXCEPTION_NOTICE_FAILED, error });
  }
}

export function* watchSendNoticeException() {
  yield takeLatest(types.SEND_EXCEPTION_NOTICE_REQUESTED, sendNoticeException);
}
